import { isNullOrUndefinedOrEmpty } from '@/utils/checkValue/string';
/**
 * パスワードが半角英数記号を1文字ずつ含むかチェック
 * @param text エラーメッセージ
 * @returns {function(*=): string}
 */
export const isValidFormatPassword = (text) => (value) => {
    if (typeof value !== 'string') {
        return text;
    }
    // 先頭・末尾にスペースがある場合はNG（Cognito対応）
    if (value !== value.trim()) {
        return text;
    }
    const hasAlphabet = /[a-zA-Z]/i.test(value);
    const hasNumber = /\d/.test(value);
    const hasSymbol = /[!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~]/g.test(value);
    if (!isNullOrUndefinedOrEmpty(value) &&
        !(hasAlphabet && hasNumber && hasSymbol)) {
        return text;
    }
    return '';
};
